module.exports = __webpack_public_path__ + "static/media/mc.b4f4b90d.svg";